import React, {
    PropTypes,
} from 'react';
import DateInput from "./DateInput";

class DateDiapason extends React.Component {
    static propTypes = {
        begin: PropTypes.object.isRequired,
        end: PropTypes.object.isRequired,
        onChange: PropTypes.func.isRequired,
    };

    onBeginChange(beginNew) {
        const {begin, end, onChange} = this.props;
        if (beginNew === begin) {
            return;
        }
        onChange(beginNew, beginNew < end ? end : beginNew);
    }

    onEndChange(endNew) {
        const {begin, end, onChange} = this.props;
        if (endNew === end) {
            return;
        }
        onChange(begin < endNew ? begin : endNew, endNew);
    }

    render() {
        const {begin, end} = this.props;
        return (
            <div className="row">
                <div className="col-md-6">
                    <DateInput date={begin} onDateChange={this.onBeginChange.bind(this)}/>
                </div>
                <div className="col-md-6">
                    <DateInput date={end} onDateChange={this.onEndChange.bind(this)}/>
                </div>
            </div>
        );
    }
}

export default DateDiapason;



/** WEBPACK FOOTER **
 ** ./src/components/DateDiapason.js
 **/